import _ from 'lodash';
import React from 'react';

import {
  Chip as MuiChip,
  Grid,
  Stack,
  styled,
  Typography
} from '@mui/material';



const Chip = styled(MuiChip, {
  shouldForwardProp: prop => prop !== 'chipVariant'
})<{chipVariant: 'outlined' | 'contained' | 'text'}>(({ chipVariant }) => ({
  border: chipVariant === 'outlined' ? '2px solid #528898' : undefined,
  background: chipVariant === 'contained' ? 'linear-gradient(98.79deg, #486C82 -32.79%, #87ACB9 77.71%, #C3D1D8 204.42%)' : 'none',
  color: chipVariant === 'contained' ? '#FFFFFF !important' : '#528898'
}));



const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2)
}));

const RootContainer = styled(Stack)(() => ({
  maxWidth: 250
}));



export interface IProps {
  chipVariant: 'contained' | 'outlined' | 'text';
  arrange?: 'stacked' | 'mason';
  alignLeft?: boolean;

  title: string;
  chipLabels: string[];
}

export const FC: React.FC<IProps> = props => {
  return (
    <RootContainer
      justifyContent="center"
      alignItems={props.alignLeft ? 'flex-start' : 'center'}>
      <StyledTitle variant="h2">
        {props.title}
      </StyledTitle>

      <Grid
        container
        spacing={2}
        justifyContent={props.alignLeft ? 'flex-start' : 'center'}
        alignItems={props.arrange === 'stacked' ? 'center' : 'flex-start'}
        direction={props.arrange === 'stacked' ? 'column' : 'row'}>
        {_.map(props.chipLabels, (label, i) => (
          <Grid
            item
            key={i}>
            <Chip
              label={label}
              chipVariant={props.chipVariant} />
          </Grid>
        ))}
      </Grid>
    </RootContainer>
  );
};
